import React from 'react';
import customReportImage from 'static/img/custom-report.png';
import expertInsightsImage from 'static/img/expert-insights.png';
import quickAssessmentImage from 'static/img/quick-assessment.png';
import tailoredGuidanceImage from 'static/img/tailored-guidance.png';

const cardImages = {
  'custom-report.png': customReportImage,
  'expert-insights.png': expertInsightsImage,
  'quick-assessment.png': quickAssessmentImage,
  'tailored-guidance.png': tailoredGuidanceImage,
};

const renderDescription = (text) => {
  const parts = text.split(/\{([^|]+)\|([^}]+)\}/);
  if (parts.length === 1) return text;
  return parts.map((part, i) => {
    if (i % 3 === 1) {
      const url = parts[i + 1];
      return (
        <a key={i} href={url} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    if (i % 3 === 2) return null;
    return part;
  });
};

const HeroCard = ({ highlights = [] }) => (
  <section className="hero-card">
    <div className="hero-card__intro">
      <h1 className="hero-card__eyebrow">Connectivity Advisor</h1>
      <p>
        Ready to explore your interconnected digital infrastructure strategy? This interactive advisor provides a quick and effective way to craft a customized
        strategy tailored to your organization's unique needs.
      </p>
    </div>
    <div className="hero-card__highlights">
      {highlights.map((item) => (
        <div key={item.title} className="highlight-card">
          <div className="highlight-card__image">
            <img src={cardImages[item.image]} alt={item.title} />
          </div>
          <h3>{item.title}</h3>
          <p>{renderDescription(item.description)}</p>
        </div>
      ))}
    </div>
    <div className="hero-card__note">
      <p>
        <strong>Note:</strong> This Connectivity Advisor is specifically developed for enterprise organizations. IT service providers, networks or other
        non-enterprise entities may not receive the most relevant insights.
      </p>
      <p>
        Design recommendations are examples to help you plan infrastructure deployment with Equinix. They may not reflect final deployment locations or
        availability.
      </p>
    </div>
    <div className="hero-card__footer-links">
      <a href="https://www.equinix.com/about/legal/terms" target="_blank" rel="noopener noreferrer">
        Terms
      </a>
      <a href="https://www.equinix.com/about/trust-security" target="_blank" rel="noopener noreferrer">
        Trust &amp; Security
      </a>
      <a href="https://www.equinix.com/about/legal/privacy" target="_blank" rel="noopener noreferrer">
        Privacy
      </a>
      <a href="https://digital.equinix.com/Preference-Management-Center-WW" target="_blank" rel="noopener noreferrer">
        Preferences
      </a>
    </div>
  </section>
);

export default HeroCard;
